import { render } from "./cfMutiline.vue?vue&type=template&id=2b11015f&ts=true"
import script from "./cfMutiline.vue?vue&type=script&lang=ts"
export * from "./cfMutiline.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__